import { useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';
import { ddexPermissionsKeys } from '~/modules/ddex-console/api/config/queryKeys';
import { getRequestHeaders } from '~settings/api/lib/headers';

import { DdexClient } from '../lib/DdexClient';
import { DdexPermissionsSchema } from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';

export function useHasLabelWithDdexEnabled<TData = boolean>(
  options?: PresetUseQueryOptions<boolean, TData>,
) {
  const { token } = useWmgSession();

  const { data, ...query } = useQuery({
    queryKey: ddexPermissionsKeys.permissions(),
    queryFn: async (): Promise<boolean> => {
      const responseData = await DdexClient.get('permissions/', {
        headers: getRequestHeaders(token),
      }).json();

      const response = DdexPermissionsSchema.parse(responseData);

      return Boolean(response['can.view.console']);
    },
    ...options,
  });

  return { hasLabelWithDdexEnabled: data, ...query };
}
